import styled from 'styled-components';

import { Flex } from '@amzn/storm-ui';

export const QueueSheetFlex = styled(Flex)`
  margin-top: 1rem;
  position: relative;

  &&& .ag-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &&& .ag-cell.ag-cell-tooltip-column {
    overflow: visible;
  }
`;

export const LoadingSpinnerFlexContainer = styled(Flex)`
 align-items:center;
 justify-contents:center;
  min-height: 20rem;
  width:100%
`;

export const ActionButtonsContainer = styled(Flex)`
  justify-content: center;
  column-gap: 0.5rem;
  flex-direction: row;
`;

export const BatchLoadingOverlay = styled(LoadingSpinnerFlexContainer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  justify-content: center;
  align-items: center;
  /* D9 = 85% opacity in hex alpha, applied to background only so spinner stays fully opaque */
  background-color: ${({ theme }) => `${theme.color.gray[50]}D9`};
`;
